import { observer } from 'mobx-react-lite';
import { SyntheticEvent, useEffect, useState } from 'react';
import {
  Button,
  Header,
  Segment,
  Form,
  Label,
  Select,
} from 'semantic-ui-react';
import { Formik } from 'formik';
import * as Yup from 'yup';
import MyTextInput from '../../app/common/form/MyTextInput';
import { v4 as uuid } from 'uuid';
import {
  camera,
  devicetypeOptions,
  fixedReader,
  kiosk,
  Led,
  server,
} from '../../app/common/options/deviceOptions/devicetypeOptions';
import { countryOptions } from '../../app/common/options/countrystateOptions/countryOptions';
import { store, useStore } from '../../app/stores/store';
import { Device, DeviceInitialState } from '../../app/models/device';

export default observer(function DeviceMasterForm() {
  const {
    DeviceStore,
    vaultStore,
    dashboardStore,
    modalStore,
    userStore: { user },
  } = useStore();
  const { selectedDevice, updateDevice } = DeviceStore;
  const { vaultitemsByDate, loadVaults, vaultRegistry } = vaultStore;
  const [isEdit, setIsEdit] = useState(false);
  const [errorType, setErrorType] = useState<string>(''); //for error text
  useEffect(() => {
    if (vaultRegistry.size <= 1) loadVaults();
  }, [vaultRegistry.size, loadVaults]);

  const [vaultName, setVaultName] = useState<string>('');
  const [deviceType, setDeviceType] = useState<string>('');
  const [deviceState, setDeviceState] = useState<Device>(DeviceInitialState);

  // updating  Data on click edit
  useEffect(() => {
    // updating
    if (
      selectedDevice?.id !== undefined &&
      dashboardStore.dashboard.formikClearFormBool === true
    ) {
      const newArr = {
        ...selectedDevice,
      };
      setIsEdit(true);
      setDeviceState(newArr);
      setDeviceType(newArr.device_Type);
      setVaultName(newArr.vaultName);
    }
    // eslint-disable-next-line
  }, [selectedDevice]);

  ////////// to get device
  const changeSelectOptionHandler = (e: any) => {
    setDeviceType(e.currentTarget.textContent);
  };

  const changeLocation = (e: SyntheticEvent, data: any) => {
    setDeviceState({ ...deviceState, [data.name]: data.value });
  };
  ////////////////////////////////////////////   to get vault ands set name
  const getSelectedVault = (e: any, data: any) => {
    setVaultName(data.value);
  };
  ////// /////////////////////////////////////////////  Form Submit
  const handleSubmit = (values: Device) => {
    if (vaultName === '') {
      setErrorType('Vault Error'); //checking errors
    } else if (deviceType === '') {
      setErrorType('Device Error'); //checking errors
    } else {
      setErrorType('');
      if (values.id === '') {
        vaultitemsByDate.forEach((vauldata) => {
          if (vaultName === vauldata.vaultName && errorType === '') {
            vauldata.deviceItemByVault = [
              {
                id: uuid(),
                vaultName: vaultName,
                device_Type: deviceType,
                selected_Device_Sub_Type: values.selected_Device_Sub_Type,
                device_Physical_Location: values.device_Physical_Location,
                reader_IP: values.reader_IP,
                port_Number: values.port_Number,
                device_Status: values.device_Status,
                isDeleted: values.isDeleted,
                isActive: values.isActive,
              },
            ];
            dashboardStore.dashboard.formikClearFormBool = false;
            DeviceStore.createDevice(vauldata); //create data
            store.DeviceStore.selectedDevice = undefined;
          }
        });
      } else {
        const updatedDeviceData = {
          ...values,
        };
        dashboardStore.dashboard.formikClearFormBool = false;
        updateDevice(updatedDeviceData); //update  data   api
        store.ShelfRackStore.selectedshelfRack = undefined;
      }
      modalStore.closeModal(); //closing modal
      setDeviceState(DeviceInitialState); //resetting data
      setIsEdit(false);
      setVaultName(''); //resetting data
      setDeviceType(''); //resetting data
    }
  };
  ////////////////////handle Change
  const handleChange = (e: any) => {
    const newArr = {
      ...deviceState,
      [e.target.name]: e.target.value,
    };
    setDeviceState(newArr);
  };
  ////////////////////handle Cancel
  const handleCancel = () => {
    setDeviceState(DeviceInitialState); //resetting data
    setIsEdit(false);
    setVaultName(''); //resetting data
    setDeviceType(''); //resetting data
    modalStore.closeModal(); //resetting data
    dashboardStore.dashboard.formikClearFormBool = false; //resetting data
    store.DeviceStore.selectedDevice = undefined; //resetting data
  };

  const vaultOptions = vaultitemsByDate.map((x) => ({
    key: x.id,
    text: x.vaultName,
    value: x.vaultName,
  }));

  return (
    <Segment clearing responsive={true} className="device-form-segment">
      <Header
        icon="edit"
        size="huge"
        dividing
        as="h1"
        content="Device Master"
        sub
        color="grey"
      />
      <Header />
      <Formik
        initialValues={deviceState}
        enableReinitialize={true}
        onSubmit={(values, { resetForm }) => {
          handleSubmit(values);
          resetForm();
        }}
        validationSchema={Yup.object({
          reader_IP: Yup.string().required('Please enter a IP'),
          port_Number: Yup.number().required('Please enter a Port Number'),
          device_Status: Yup.string().required(
            'Please enter the device status',
          ),
        })}
      >
        {({ handleSubmit }) => (
          <Form className="ui form error" autoComplete="off">
            <Form.Group widths="equal">
              <Form.Field
                style={{
                  pointerEvents: isEdit ? 'none' : 'auto',
                  opacity: isEdit ? '0.7' : '1',
                }}
                control={Select}
                options={vaultOptions}
                label={user?.customerName === 'LVP CMS - AM' ? 'Room' : 'Vault'}
                name="vaultName"
                placeholder={
                  user?.customerName === 'LVP CMS - AM' ? 'Room' : 'Vault'
                }
                value={vaultName}
                onChange={(e: any, data: any) => getSelectedVault(e, data)}
              />
              {/* <label style={{ marginBottom: "5px", color: "black" }}>
                    Vault
                  </label>
                  <Dropdown
                    placeholder="Vault"
                    name="vaultName"
                    label="Vault"
                    fluid
                    selection
                    options={vaultOptions}
                    value={vaultName}
                    onChange={(e: any, data) => getSelectedVault(e, data)}
                  /> */}
              {errorType === 'Vault Error' && (
                <Label basic color="red" style={{ marginTop: '0px' }}>
                  Please Enter a Vault
                </Label>
              )}
              <Form.Field
                control={Select}
                value={deviceType}
                options={devicetypeOptions}
                label="Device Type"
                name="device_Type"
                placeholder="Device Type"
                clearable={true}
                onChange={changeSelectOptionHandler}
              />
              {/* <label style={{ marginBottom: "5px", color: "black" }}>
                    Device Type
                  </label>
                  <Dropdown
                    fluid
                    selection
                    options={devicetypeOptions}
                    name="device_Type"
                    placeholder="Device Type"
                    value={deviceType}
                    onChange={changeSelectOptionHandler}
                  /> */}

              {errorType === 'Device Error' && (
                <Label basic color="red" style={{ marginTop: '-3px' }}>
                  Please Enter a Device
                </Label>
              )}
              {deviceType && (
                <>
                  {/* <label style={{ marginBottom: "5px", color: "black" }}>
                        Sub Type
                      </label> */}
                  {/* <Dropdown
                        name="selected_Device_Sub_Type"
                        placeholder="Sub Type"
                        fluid
                        selection
                        label={deviceType}
                        value={deviceState.selected_Device_Sub_Type}
                        onChange={changeLocation}
                        options={
                          deviceType === "KIOSK"
                            ? kiosk
                            : deviceType === "Fixed Reader"
                            ? fixedReader
                            : deviceType === "LED Device"
                            ? Led
                            : deviceType === "Server"
                            ? server
                            : deviceType === "Camera"
                            ? camera
                            : fixedReader
                        }
                      /> */}
                  <Form.Field
                    control={Select}
                    value={deviceState.selected_Device_Sub_Type}
                    options={
                      deviceType === 'KIOSK'
                        ? kiosk
                        : deviceType === 'Fixed Reader'
                          ? fixedReader
                          : deviceType === 'LED Device'
                            ? Led
                            : deviceType === 'Server'
                              ? server
                              : deviceType === 'Camera'
                                ? camera
                                : fixedReader
                    }
                    label="Sub Type"
                    name="selected_Device_Sub_Type"
                    placeholder="Sub Type"
                    clearable={true}
                    onChange={changeLocation}
                  />
                </>
              )}
            </Form.Group>
            <Form.Group widths="equal">
              {/* <label style={{ marginBottom: "5px", color: "black" }}>
                    Physical Location
                  </label>
                  <Dropdown
                    label="Physical Location"
                    options={countryOptions}
                    fluid
                    selection
                    name="device_Physical_Location"
                    placeholder="--Select Location--"
                    value={deviceState.device_Physical_Location}
                    onChange={changeLocation}
                  /> */}
              <Form.Field
                control={Select}
                value={deviceState.device_Physical_Location}
                options={countryOptions}
                label="Physical Location"
                name="device_Physical_Location"
                placeholder="--Select Location--"
                clearable={true}
                onChange={changeLocation}
              />
              <MyTextInput
                label="Reader IP"
                name="reader_IP"
                placeholder="Reader IP"
                value={deviceState.reader_IP}
                onChange={handleChange}
              />
              <MyTextInput
                label="Port No."
                name="port_Number"
                placeholder="Port Number"
                type="number"
                value={deviceState.port_Number}
                onChange={handleChange}
              />
              <MyTextInput
                label="Device Status"
                name="device_Status"
                placeholder="Device Status"
                value={deviceState.device_Status}
                onChange={handleChange}
              />
            </Form.Group>
            <Button.Group floated="right" style={{ marginTop: '20px' }}>
              <Button type="reset" onClick={handleCancel}>
                Cancel{' '}
              </Button>
              <Button.Or />
              <Button
                disabled={!deviceState.selected_Device_Sub_Type}
                onClick={() => handleSubmit()}
                type="submit"
                content="Submit"
                positive
              >
                Submit
              </Button>
            </Button.Group>
          </Form>
        )}
      </Formik>
    </Segment>
  );
});
